import { useEffect } from 'react'
import { useTranslation } from 'next-i18next'

import { useAppSelector } from '~/redux/hooks'

import ButtonGoogleLogin from '~/auth/components/ButtonGoogleLogin'
import ButtonFacebookLogin from '~/auth/components/ButtonFacebookLogin'
import { selectBackendError } from '~/auth/slices/login.slice'

import LoginServerError from '~/auth/components/LoginServerError'
import authService from '~/services/auth.service'
import ButtonEmailRegister from '~/auth/components/ButtonEmailRegister'

export default function CampaignAuthButtons({ redirectRoute }: { redirectRoute: string }): React.ReactElement {
  const { t } = useTranslation(['logIn', 'authenticate', 'campaign'])
  const backendError = useAppSelector(selectBackendError)

  useEffect(() => {
    authService.setRedirectTo(redirectRoute)
  }, [redirectRoute])

  return (
    <div className="w-full h-full space-y-4 flex flex-col items-center justify-center">
      <ButtonEmailRegister buttonText={t('campaign:accessWithEmail')} redirectRoute={redirectRoute} />
      <ButtonGoogleLogin buttonText={t('campaign:accessWithGoogle')} />
      <ButtonFacebookLogin buttonText={t('campaign:accessWithFacebook')} color="white" />

      <LoginServerError message={backendError} />
    </div>
  )
}
